"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Data = void 0;
const base_1 = require("../base");
/** Attributes of a model item as submitted in a Model POST request */
exports.Data = base_1.ModelIdData;
